module.exports = __webpack_public_path__ + "img/text2_zhCn@3x.0056aa7b.png";